import axios, { AxiosRequestHeaders } from 'axios';
import { Message } from 'element-ui';
import qs from 'qs';
import { ElMessageComponent } from 'element-ui/types/message';
import { directDownloadFn } from './base';
import 'element-ui/packages/theme-chalk/src/message-box.scss';

const service = axios.create({
  baseURL: import.meta.env.ROSA_BASE_API,
  timeout: 60000,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});

service.interceptors.request.use(
  async (config) => {
    config.headers = {
      ...getTokenHeader(),
      'Content-Type':
        config.data instanceof FormData ? 'application/x-www-form-urlencoded' : 'application/json;charset=utf-8',
      ...config.headers,
    } as unknown as AxiosRequestHeaders;

    return config;
  },
  (error) => {
    throw new Error(error);
  },
);

let message: ElMessageComponent;

let isLoggingOut = false;

service.interceptors.response.use(
  (res: any) => {
    const { lockTimeout } = useAppStore();

    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
      lockTimeout();

      // 是否直接通过 directDownloadFn 下载文件
      const directDownload = res.config?.directDownload;
      if (directDownload === '1') {
        directDownloadFn(res);
        return res.data;
      }
      return res.data;
    }

    const code = res.data.code;

    const userStore = useUserStore();

    if (code !== 200) {
      switch (code) {
        case 401:
          if (!message) {
            message = Message.warning('登录已过期，请重新登录');
          }
          if (window.location.hash.indexOf('/login') !== 0) {
            location.reload();
          }
          userStore.logout();
          return Promise.reject(new Error('无效的会话，或者会话已过期，请重新登录。'));
        default:
          Message({ message: res.data.msg, type: 'error' });
          return Promise.reject(new Error(res.data.msg));
      }
    }
    lockTimeout();
    return res.data;
  },
  (error) => {
    // 请求被取消时，axios 会自动加上 code: 'ERR_CANCELED'
    if (axios.isCancel(error) || error.code === 'ERR_CANCELED') {
      // 👇 忽略被取消的请求，不进行错误提示、不上报
      return Promise.resolve(null);
    }
    if (error?.status === 401 || error?.response?.status === 401 || error?.response?.data?.code === 401) {
      if (isLoggingOut) {
        return Promise.reject(error);
      }
      isLoggingOut = true;
      Message.warning('登录已过期，请重新登录');
      const userStore = useUserStore();
      userStore.logout();
      setTimeout(() => {
        isLoggingOut = false;
      }, 500);
      if (window.location.hash.indexOf('/login') !== 0) {
        location.reload();
      }
      return;
    }
    let { message } = error;
    if (message === 'Network Error') {
      message = '后端接口连接异常';
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时';
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常';
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  },
);

export default service;
